import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


const PaygroupForm = ({ paygroupId, initialData, onSuccess }) => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [paygroupName, setPaygroupName] = useState('');
     const [loading, setLoading] = useState(false);
     const [error, setError] = useState('');
     const navigate = useNavigate();

     // ✅ Fill form if initialData is provided (edit mode)
     useEffect(() => {
          if (initialData && initialData.paygroup) {
               setPaygroupName(initialData.paygroup);
          }
     }, [initialData]);

     const handleSubmit = async (e) => {
          e.preventDefault();

          if (!paygroupName.trim()) {
               setError('Paygroup name is required');
               return;
          }

          setLoading(true);
          setError('');

          try {
               let url = '';
               let method = 'POST';
               let body = {};

               if (paygroupId) {
                    // ✅ Edit mode
                    url = `${baseUrl}/updateUserPayGroupById/${paygroupId}`;
                    body = { paygroup: paygroupName };
               } else {
                    // ✅ Create mode
                    url = `${baseUrl}/createUserPayGroup`;
                    body = { paygroup: paygroupName };
               }

               const response = await fetch(url, {
                    method,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body),
               });

               const data = await response.json();

               if (data.status) {
                    alert(paygroupId ? 'Paygroup updated successfully' : 'Paygroup created successfully');
                    if (onSuccess) onSuccess();
                    navigate('/paygroup');
               } else {
                    setError(data.message || `Failed to ${paygroupId ? 'update' : 'create'} PYAGROUP`);
               }
          } catch (err) {
               setError('Error connecting to server');
          } finally {
               setLoading(false);
          }
     };

     return (
          <form className="general-info-form" onSubmit={handleSubmit}>
               <h2 className="section-title">{paygroupId ? 'Edit Paygroup' : 'Add Paygroup'}</h2>
               <div className="form-grid">
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control"
                              id="paygroupName"
                              placeholder=" "
                              autoComplete="off"
                              value={paygroupName}
                              onChange={(e) => setPaygroupName(e.target.value)}
                              disabled={loading}
                         />
                         <label htmlFor="paygroupName">Paygroup Name</label>
                    </div>
               </div>
               {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
               <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ marginTop: '15px' }}
                    disabled={loading}
               >
                    {loading ? 'Saving...' : 'Save'}
               </button>
          </form>
     );
};

export default PaygroupForm;
